export const CALENDAR_URL =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3mPXvDytS7saA9nWYQ1hTMdVDUx_m71M_LKlsURNTF0W3i5hm0R_B7tNnOCsW0DK-CJB_eoMbA";

// Add other application URLs here as needed
export const APP_URLS = {
  CALENDAR: CALENDAR_URL,
  // Add other URLs here as needed
} as const;
